module.exports = __webpack_public_path__ + "img/horizontal_3_3_pp3_8.af3f76f6.png";